import { DwModuleType, DwVersionInfo } from "@devwareapps/devware-cap";

export const angularApplicationVersion: DwVersionInfo = {
    ModuleName: 'Pilexos-Angular',
    ModuleType: DwModuleType.application,
    ProductVersion: '2.1.259',
    PublishDateTime: '10/23/2026 09:45:38 AM'
}
